<template>
  <div>
    <div class="d-flex align-items-center">
      <div style="background: #CFAD6C;border-radius: 50px;width: 9px; height: 2px;margin-left: 1px"></div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-left: 3px"></div>
      <div class="headerStyle">محصولات</div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 27px; height: 2px;margin-right: 3px"></div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-right: 1px"></div>
    </div>
    <div v-for="product in productData.invoiceItem" :key="product.id" class="products">
      <div>
        <img class="productImage" :src="product.product.image" :alt="product.product.title" />
      </div>
      <div>
        <div class="productTitle">{{ product.product.title }}</div>
        <div v-for="item in product.product.properties" :key="item.id" class="itemClass">
          <div>{{ item.key }} :</div>
          <div>{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productData: {
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
.headerStyle {
  color: #414141;
  font-size: 18px;
}
.products {
  display: flex;
}
.productImage {
  width: 190px;
  height: 190px;
}
.productTitle {
  font-size: 18px;
  color: #4a4a4a;
  margin-bottom: 14px;
}
.itemClass {
  display: flex;
  margin: 6px 0;
}
@media only screen and (max-width: 768px) {
  .headerStyle {
    font-size: 16px;
  }
  .productImage {
    width: 140px;
    height: 140px;
  }
}
@media only screen and (max-width: 576px) {
  .headerStyle {
    font-size: 14px;
  }
  .productImage {
    width: 270px;
    height: 270px;
  }
  .products {
    flex-direction: column;
  }
}
</style>
